export class LandingSiteContactDetails {
    public plannedDate: Date;
    public directionPrefix: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public contactNumber: string;
    public contactNumberExtension: string;
    public deliveryPressure: string;
    public other: string;
}
